import NextLink from 'next/link';

interface LinkProps {
  href: string;
  children: React.ReactNode;
  download?: boolean;
  active?: boolean;
}

function Link(props: LinkProps) {
  return <NextLink href={props.href}>{props.children}</NextLink>;
}

export default Link;
